import styled from 'react-emotion'

const Footnote = styled('p')`
	color: #767676;
	font-size: 0.9rem;
	font-style: italic;
	margin: 3rem 0;
	text-align: center;
`

export default Footnote
